/**
 * Posture Scan Configuration
 * 
 * API credentials and endpoints for the Watch Your Health Posture Scan API
 */

// Read API key from environment variable
const API_KEY = process.env.REACT_APP_WYH_POSTURE_API_KEY;

// API Endpoint
export const POSTURE_SCAN_API_URL = 'https://prd.server.watchyourhealth.com/apis/s/posture-scan';

// Export API key (will be checked before API calls)
export const POSTURE_SCAN_API_KEY = API_KEY;

// Check if API key is configured
export const isPostureScanConfigured = (): boolean => {
  return !!API_KEY && API_KEY.trim().length > 0;
};

// Get configuration error message
export const getConfigErrorMessage = (): string => {
  if (!API_KEY) {
    return 'Posture Scan API key is not configured. Please add REACT_APP_WYH_POSTURE_API_KEY to your .env file.';
  }
  return 'Invalid API configuration.';
};

// Storage keys for persisting data
export const STORAGE_KEYS = {
  USER_DATA: 'postureScan_userData',
  IMAGES: 'postureScan_images',
  RESULTS: 'postureScan_results',
} as const;

// Image validation settings (matching facescan style)
export const IMAGE_VALIDATION = {
  MAX_SIZE_MB: 10,
  MAX_SIZE_BYTES: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.heic', '.heif'],
} as const;
